export const MARKETING_PARTNER_LISTING_STATUS_LANDLORD_INVITED = 'landlordInvited';
export const MARKETING_PARTNER_LISTING_STATUS_IN_PROGRESS = 'InProgress';
export const MARKETING_PARTNER_LISTING_STATUS_COMPLETED = 'Completed';
export const MARKETING_PARTNER_LISTING_STATUS_TEMPORARILY_OFF_MARKET = 'TemporarilyOffMarket';
export const MARKETING_PARTNER_LISTING_STATUS_WITHDRAWN = 'Withdrawn';
export const MARKETING_PARTNER_LISTING_STATUS_REQUEST_WITHDRAWN = 'RequestWithdrawn';

export const MARKETING_PARTNER_LISTING_CATEGORY_PRE_LEASE = 'preLease';
export const MARKETING_PARTNER_LISTING_CATEGORY_MOVE_IN_READY = 'moveInReady';
export const MARKETING_PARTNER_LISTING_CATEGORY_TOUR_SETUP = 'tourSetup';

export const MARKETING_PARTNER_LISTING_STATUS_OPTION_ITEMS = [
  {
    label: 'Go to Market',
    value: MARKETING_PARTNER_LISTING_STATUS_IN_PROGRESS,
  },
  {
    label: 'Temporarily Off Market',
    value: MARKETING_PARTNER_LISTING_STATUS_TEMPORARILY_OFF_MARKET,
  },
  {
    label: 'Withdrawn',
    value: MARKETING_PARTNER_LISTING_STATUS_WITHDRAWN,
  },
];

export const MARKETING_PARTNER_LISTING_AGREEMENT_SIGNED_BY_SUNROOM = 'Sunroom';
export const MARKETING_PARTNER_LISTING_AGREEMENT_SIGNED_BY_AGENT = 'Agent';

export const MARKETING_PARTNER_LISTING_AGREEMENT_SIGNED_BY_OPTION_ITEMS = [
  {
    label: 'Sunroom',
    value: MARKETING_PARTNER_LISTING_AGREEMENT_SIGNED_BY_SUNROOM,
  },
  {
    label: 'Agent',
    value: MARKETING_PARTNER_LISTING_AGREEMENT_SIGNED_BY_AGENT,
  },
];

export const MARKETING_PARTNER_LISTING_TEMPORARILY_OFF_MARKET_REASON_OTHER = 'Other';
export const MARKETING_PARTNER_LISTING_WITHDRAWN_REASON_OTHER = 'Other';

export const MARKETING_PARTNER_LISTING_TEMPORARILY_OFF_MARKET_REASON_OPTION_ITEMS = [
  'App Pending',
  'Maintenance issues',
  'Repairs/renovations',
  MARKETING_PARTNER_LISTING_TEMPORARILY_OFF_MARKET_REASON_OTHER,
].map((option) => ({
  label: option,
  value: option,
}));

export const MARKETING_PARTNER_LISTING_WITHDRAWN_REASON_OPTION_ITEMS = [
  'Leased by on-site team',
  'Transferred a resident',
  'Owner off boarding',
  MARKETING_PARTNER_LISTING_WITHDRAWN_REASON_OTHER,
].map((option) => ({
  label: option,
  value: option,
}));

export const MARKETING_PARTNER_LISTING_WITHDRAWN_STATUSES = [
  MARKETING_PARTNER_LISTING_STATUS_WITHDRAWN,
  MARKETING_PARTNER_LISTING_STATUS_REQUEST_WITHDRAWN,
  MARKETING_PARTNER_LISTING_STATUS_TEMPORARILY_OFF_MARKET,
];

export const MARKETING_PARTNER_LISTING_ACTIVE_STATUSES = [
  MARKETING_PARTNER_LISTING_STATUS_IN_PROGRESS,
  MARKETING_PARTNER_LISTING_STATUS_COMPLETED,
];

export const MARKETING_PARTNER_LISTING_GOING_TO_MARKET_STEP_STATUS_NOT_STARTED = 'NotStarted';
export const MARKETING_PARTNER_LISTING_GOING_TO_MARKET_STEP_STATUS_IN_PROGRESS = 'InProgress';
export const MARKETING_PARTNER_LISTING_GOING_TO_MARKET_STEP_STATUS_COMPLETED = 'Completed';

export const MARKETING_PARTNER_LISTING_INSTALL_STATUS_IN_PROGRESS = 'InProgress';
export const MARKETING_PARTNER_LISTING_INSTALL_STATUS_COMPLETED = 'Completed';

export const MARKETING_PARTNER_LISTING_INSTALL_STATUSES = [
  MARKETING_PARTNER_LISTING_INSTALL_STATUS_COMPLETED,
  MARKETING_PARTNER_LISTING_INSTALL_STATUS_IN_PROGRESS,
];

export const MARKETING_PARTNER_LISTING_UPDATE_STATUS_WITHDRAW_FROM_MARKET = 'withdraw-from-market';
export const MARKETING_PARTNER_LISTING_UPDATE_STATUS_TEMPORARILY_OFF_MARKET =
  'temporarily-off-market';
export const MARKETING_PARTNER_LISTING_UPDATE_STATUS_BRING_BACK_ON_MARKET = 'bring-back-on-market';
export const MARKETING_PARTNER_LISTING_UPDATE_STATUS_MARK_AS_RESOLVED = 'mark-as-resolved';

export const PROPERTY_SETUP_ACCESS_TYPE_USE_ACCESS_CODE = 'UseAccessCode';
export const PROPERTY_SETUP_ACCESS_TYPE_COMBO_LOCKBOX = 'CombinationLockbox';
export const PROPERTY_SETUP_ACCESS_TYPE_CONTACT_FOR_KEY = 'ContactForKey';
export const PROPERTY_SETUP_ACCESS_TYPE_HIDDEN = 'HiddenKey';
export const PROPERTY_SETUP_ACCESS_TYPE_SUPRA_LOCKBOX = 'SupraLockbox';

export const PROPERTY_SETUP_ACCESS_TYPE_OPTION_ITEMS = [
  {
    label: 'Combination Lockbox',
    value: PROPERTY_SETUP_ACCESS_TYPE_COMBO_LOCKBOX,
  },
  {
    label: 'Key will be hidden',
    value: PROPERTY_SETUP_ACCESS_TYPE_HIDDEN,
  },
  {
    label: 'Supra Lockbox',
    value: PROPERTY_SETUP_ACCESS_TYPE_SUPRA_LOCKBOX,
  },
  {
    label: 'Contact Person for Keys',
    value: PROPERTY_SETUP_ACCESS_TYPE_CONTACT_FOR_KEY,
  },
];

export const PROPERTY_SETUP_ACCESS_METHOD_TYPE_KEY = 'Key';
export const PROPERTY_SETUP_ACCESS_METHOD_TYPE_CODE = 'Access Code';
export const PROPERTY_SETUP_ACCESS_METHOD_TYPE_SUNRISE_KEY = 'Sunrise Key';
export const PROPERTY_SETUP_ACCESS_METHOD_TYPE_SUNRISE_NO_KEY = 'Sunrise No Key';

export const PROPERTY_SETUP_ACCESS_METHOD_OPTION_ITEMS = [
  {
    label: 'Key (combo, Supra, etc.)',
    value: PROPERTY_SETUP_ACCESS_METHOD_TYPE_KEY,
  },
  {
    label: 'Access Code (no key)',
    value: PROPERTY_SETUP_ACCESS_METHOD_TYPE_CODE,
  },
];

export const AVAILABLE_FOR_PHOTO_DATE_SCHEDULE_ANY_TIME = 'AnyTime';
export const AVAILABLE_FOR_PHOTO_DATE_SCHEDULE_CALL_TO_SCHEDULE = 'CallToSchedule';

export const AVAILABLE_FOR_PHOTO_DATE_SCHEDULE_OPTION_ITEMS = [
  {
    label: 'Go any time',
    value: AVAILABLE_FOR_PHOTO_DATE_SCHEDULE_ANY_TIME,
  },
  {
    label: 'Call to schedule',
    value: AVAILABLE_FOR_PHOTO_DATE_SCHEDULE_CALL_TO_SCHEDULE,
  },
];

export const AVAILABLE_FOR_PHOTO_DATE_SCHEDULE_VALUES = AVAILABLE_FOR_PHOTO_DATE_SCHEDULE_OPTION_ITEMS.map(
  ({ value }) => value,
);

export const MARKETING_PARTNER_LISTING_SUNROOM_COMMISSION = 0.85;

export const PROPERTY_CONDITION_REPORT_IN_PROGRESS_STATE = {
  label: 'In Progress',
  value: null,
  labelColor: 'blue300',
  copyTitle: null,
  copyText:
    'Sunroom is on-site and assessing the physical condition of the property for you,' +
    ' and will create a report to summarizes everything.' +
    ' The report will show here when completed',
};
export const PROPERTY_CONDITION_REPORT_IN_PROGRESS_TEXT =
  'Sunroom is on-site and assessing the physical condition of the property for you,' +
  ' and will create a report to summarizes everything.' +
  ' The report will show here when completed';

export const PROPERTY_CONDITION_REPORT_MAPPING = [
  {
    label: 'None, Choose Condition',
    value: null,
    labelColor: null,
    copyTitle: null,
    copyText: null,
  },
  {
    label: 'Excellent',
    value: 'excellent',
    labelColor: 'green',
    copyTitle: '5% of homes we inspect.',
    copyText: 'This home is in excellent condition.',
  },
  {
    label: 'Good',
    value: 'good',
    labelColor: 'green',
    copyTitle: '50% of homes we inspect',
    copyText: 'This home is ready to lease but has some minor problems that need to be addressed.',
  },
  {
    label: 'Fair',
    value: 'fair',
    labelColor: 'orange300',
    copyTitle: '35% of homes we inspect',
    copyText:
      'This home has quite a few problems that need some attention to get it leased promptly.',
  },
  {
    label: 'Poor',
    value: 'poor',
    labelColor: 'red',
    copyTitle: '19% of homes we inspect',
    copyText:
      'This home could use immediate attention and is at risk of being on market for an extended period.',
  },
  {
    label: 'Un-Rentable',
    value: 'unrentable',
    labelColor: 'red',
    copyTitle: '1% of homes we inspect',
    copyText: 'This home needs urgent repairs and attention in order to get the listing live.',
  },
];
